import React from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import AsyncSelect from 'react-select/async';
import { reactLocalStorage } from 'reactjs-localstorage';

import MainSearchAPI from '../../api/MainSearchAPI';
import Display from '../../util/Display';
import Const from '../../util/Constants';
import ContactController from '../../controller/ContactController';

import FieldText from '../common/FieldText';
import FieldSelect from '../common/FieldSelect';
import FieldMultiPhone from '../common/FieldMultiPhone';
import FieldMultiValue from '../common/FieldMultiValue';

import Util from '../../util/Util';

class ProjectContactPopup extends React.Component {

constructor(props) {
  super(props);

  const models = reactLocalStorage.getObject(Const.Model);
  this.model = models.contact;
  this.user = reactLocalStorage.getObject(Const.LoggedInUser);
  
  this.contact = ContactController.addModel(this.model.fields);
  this.contact.model_id = props.model_id;
  this.contact.model_no = props.model_no;
  this.contact.id = 0;

  const ContactRestrict = Util.isAllow(
    models.contact.permission,
    Const.PermRestricAcc
  );

  this.SearchBody = {};
  if (ContactRestrict) {
    this.SearchBody.contact = [{
      field: 'responsible_person',
      type: 'multiselect~user',
      condition: 'in',
      value: `~${[this.user.user_id, ...this.user.child].join('~')}~`
    }];
  }

  this.state = {
    mode: 'existing',
    selected: null,
    search: '',
    inValid: {},
    contact: { ...this.contact }
  };
}

  onSearch = (text, callback) => {
    if (text.length <= 2) return callback([]);

    MainSearchAPI.list(text, this.SearchBody, res => {
      const contacts = res.contacts
        ? res.contacts.map(c => ({
            value: c.id,
            label: Display.ModelName(c)
          }))
        : [];
      callback(contacts);
    });
  };

  onSelectChange = selected => {
    this.setState({ selected });
  };

  onValueChange = (field, value) => {
    const contact = { ...this.state.contact };
    contact[field] = value;
    this.setState({ contact });
  };

  addExistingContact = () => {
    if (!this.state.selected) return;
  
  this.props.addContact({
    contact: this.state.selected.value,
    project: this.props.model_id
  });
};

quickSaveContact = () => {
  
  if (!this.user || !this.user.user_id) {
    return;
  }

  const contactData = {
    newContact: {
      id: 0,
      ...this.state.contact,
      responsible_person: `~${this.user.user_id}~`
    },
    project: this.props.model_id
  };

  this.props.addContact(contactData);
};

  render() {
    const { mode, selected, contact, inValid } = this.state;
    const fields = this.model.fields;

    return (
      <Modal show={this.props.show} onHide={this.props.onHide} centered size="lg">
        <Modal.Header closeButton className="bg-light">
          <Modal.Title className="fw-semibold">
            Project Contact
          </Modal.Title>
        </Modal.Header>

        <Modal.Body className="p-4">

          <div className="d-flex justify-content-center">
            <div className="btn-group btn-group-sm">
              <Button
                variant={mode === 'existing' ? 'primary' : 'outline-primary'}
                onClick={() => this.setState({ mode: 'existing', selected: null })}
              >
                Existing Contact
              </Button>

              <Button
                variant={mode === 'new' ? 'primary' : 'outline-primary'}
                onClick={() => this.setState({ mode: 'new', selected: null })}
              >
                Add New Contact
              </Button>
            </div>
          </div>

          {mode === 'existing' && (
            <div className="card border-0 shadow-sm">
              <div className="card-body">
                <h6 className="fw-semibold mb-3 text-muted">
                  Select Existing Contact
                </h6>

                <AsyncSelect
                  cacheOptions
                  isClearable
                  loadOptions={this.onSearch}
                  onChange={this.onSelectChange}
                  placeholder="Search by name, email, phone..."
                />

                <div className="text-end mt-4">
                  <Button
                    onClick={this.addExistingContact}
                    disabled={!selected}
                  >
                    Add Contact
                  </Button>
                </div>
              </div>
            </div>
          )}

          {mode === 'new' && (
            <div className="card border-0 shadow-sm">
              <div className="card-body">
                <h6 className="fw-semibold mb-4 text-muted">
                  Create New Contact
                </h6>

                <Form>
                  <div className="row g-3">

                    <div className="col-md-6">
                      <FieldText
                        id="firstname"
                        field={fields.firstname}
                        value={contact.firstname}
                        onValueChange={this.onValueChange}
                        inValid={inValid}
                      />
                    </div>

                    <div className="col-md-6">
                      <FieldText
                        id="lastname"
                        field={fields.lastname}
                        value={contact.lastname}
                        onValueChange={this.onValueChange}
                        inValid={inValid}
                      />
                    </div>

                    <div className="col-md-6">
                      <FieldMultiPhone
                        id="phone"
                        field={fields.phone}
                        value={contact.phone}
                        onValueChange={this.onValueChange}
                        inValid={inValid}
                      />
                    </div>

                    <div className="col-md-6">
                      <FieldMultiValue
                        id="email"
                        field={fields.email}
                        value={contact.email}
                        onValueChange={this.onValueChange}
                        inValid={inValid}
                      />
                    </div>

                    <div className="col-md-6">
                      <FieldSelect
                        id="contact_type"
                        field={fields.contact_type}
                        value={contact.contact_type}
                        onValueChange={this.onValueChange}
                        inValid={inValid}
                      />
                    </div>

                  </div>

                  <div className="text-end mt-4">
                    <Button onClick={this.quickSaveContact}>
                      Create & Add Contact
                    </Button>
                  </div>
                </Form>
              </div>
            </div>
          )}

        </Modal.Body>
      </Modal>
    );
  }
}

export default ProjectContactPopup;
